module.exports = __webpack_public_path__ + "media/engine1.8797cdb1.ogg";